import { replaceSpecialChars } from './gtmAnalyticsUtils';

function breadcrumbsEvents() {
  [].forEach.call(document.querySelectorAll('.js-tracking-breadcrumbs:not([data-analytics-attached])'), element => {
    element.setAttribute('data-analytics-attached', true);
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'visitor interaction',
        interaction_name: 'breadcrumb click',
        breadcrumb_url: `${window.location.protocol}//${window.location.hostname}${element.getAttribute('href')}`,
      });
    });
  });
}

function swatchListEvents() {
  [].forEach.call(document.querySelectorAll('.js-tracking-color-swatches:not([data-analytics-attached])'), element => {
    element.setAttribute('data-analytics-attached', true);
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'visitor interaction',
        interaction_name: 'alternative colours click',
        colour_selected: replaceSpecialChars(element.dataset.trackingName),
      });
    });
  });
}

export function accordionEvents() {
  [].forEach.call(document.querySelectorAll('.js-tracking-accordion:not([data-analytics-attached])'), element => {
    element.setAttribute('data-analytics-attached', true);
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'visitor interaction',
        interaction_name: 'tab click',
        tab_name: replaceSpecialChars(element.dataset.trackingName),
      });
    });
  });
}

export function createDlTrackSizeSelector() {
  let selectedSize = null;

  return {
    dlTrackSizeSelecting({ dataLayerName, errorMessage }) {
      if (dataLayerName) {
        selectedSize = dataLayerName;

        window.dataLayer.push({
          event: 'visitor interaction',
          interaction_name: 'size button click',
          size_button_size: replaceSpecialChars(dataLayerName).trim(),
          size_button_stock_messages: errorMessage || '',
        });
      }
    },
    dlTrackSizeDeselecting({ dataLayerName }) {
      const ERROR_MESSAGE_TIMEOUT = 500;

      setTimeout(() => {
        const errorMessage = document.querySelector('.pdp__select-size__error .form-msg-error');
        selectedSize = null;

        window.dataLayer.push({
          event: 'visitor interaction',
          interaction_name: 'size button click',
          size_button_size: replaceSpecialChars(dataLayerName).trim(),
          size_button_stock_messages: errorMessage ? 'please select a size' : '',
        });
      }, ERROR_MESSAGE_TIMEOUT);
    },
    dlTrackSizeGuideClick() {
      const sizeGuideButton = document.querySelector('.js-tracking-size-guide:not([data-analytics-attached])');
      if (sizeGuideButton) {
        sizeGuideButton.setAttribute('data-analytics-attached', true);
        sizeGuideButton.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'visitor interaction',
            interaction_name: 'size guide click',
            size_guide_size: selectedSize ? replaceSpecialChars(selectedSize).trim() : 'none',
          });
        });
      }
    },
  };
}

export function dlTrackStickyAddToBagClick() {
  const stickyATBbutton = document.querySelector('.js-tracking-sticky-atb:not([data-analytics-attached])');
  if (stickyATBbutton) {
    stickyATBbutton.setAttribute('data-analytics-attached', true);
    stickyATBbutton.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'visitor interaction',
        interaction_name: 'pdp reveal sizes click',
      });
    });
  }
}

export function dlTrackCtaLinkClick() {
  window.dataLayer.push({
    event: 'visitor interaction',
    interaction_name: 'Customer selected linked product CTA link from PDP',
    product_id: window.inlineProductDetails.productCode,
  });
}

export default function dlTrackPDPEvents() {
  breadcrumbsEvents();
  swatchListEvents();
  accordionEvents();
}

export const dlSizeSelectorTracker = createDlTrackSizeSelector();
